import { ERROR_FRAGMENT } from 'providers/tanstack-query/errors'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { Data, Variables } from './types'

export const UPSERT_WORKSPACE_AMAZON: TypedDocumentNode<Data, { input: Variables }> = gql`
  ${ERROR_FRAGMENT}

  mutation upsertWorkspaceAmazon($input: UpsertWorkspaceAmazonInput!) {
    upsertWorkspaceAmazon(input: $input) {
      errors {
        ...ErrorFragment
      }
    }
  }
`
